/** CSGCylinder3D registration: the parser. */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseCSGCylinder3D } from './parser';
const csgCylinder3DRegistration = {
    typeName: 'CSGCylinder3D',
    parser: parseCSGCylinder3D,
};
nodeRegistry.register(csgCylinder3DRegistration);
export * from './parser';
export * from './types';
//# sourceMappingURL=index.js.map